class SafeLoadScripts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    Array.from(this.children).forEach((script) => {
      if (script.tagName !== 'SCRIPT') return;
      const key = script.dataset.flowLoadKey;
      if (key && window.wetheme.webcomponentRegistry.checkScriptLoaded(key)) return;

      const postLoadedScript = document.createElement('script');
      const { src, defer, async, type } = script;
      postLoadedScript.src = src;
      postLoadedScript.defer = defer;
      postLoadedScript.async = async;
      postLoadedScript.type = type;
      this.parentElement.appendChild(postLoadedScript);
    });
  }
}

customElements.define('safe-load-scripts', SafeLoadScripts);
